import { useState } from 'react';
import ItemRow from '../components/ItemRow';
import Sorted from '../components/Sorted';
import BackButton from '../components/BackButton';
import usePlayer from '../contexts/usePlayer';
import useAuth from '../contexts/useAuth';
import useToast from '../contexts/useToast';
import type { ListData } from '../../../types';

const Queue = () => {
  const { nowPlayingId, play, isPlaying } = usePlayer();
  const { user } = useAuth();
  const isAdmin = user?.isAdmin;
  const { showToast } = useToast();
  const [queueVersion, setQueueVersion] = useState(0);

  return (
    <div className="page">
      <p className="section-title" style={{ marginTop: '20px' }}>
        Queue
      </p>
      <BackButton />
      <div style={{ marginTop: '20px' }}>
        <Sorted<ListData>
          route="/api/queue"
          render={(item) => (
            <ItemRow key={item.id} data={item} noMargin isAdmin={isAdmin} />
          )}
          deps={[nowPlayingId, queueVersion]}
          emptyMessage="Queue is empty"
          onRemove={async (item) => {
            await fetch('/api/queue/remove', {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ contentId: item.id }),
            });
            showToast('Removed from queue', 'info', true, {
              label: 'Undo',
              onClick: async () => {
                await fetch('/api/queue/add', {
                  method: 'POST',
                  credentials: 'include',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ contentId: item.id }),
                });
                setQueueVersion((v) => v + 1);
              },
            });
          }}
          onReorder={async (reordered) => {
            // Update queue positions on server
            await fetch('/api/queue/reorder', {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                positions: reordered.map((queueItem, index) => ({
                  contentId: queueItem.id,
                  queuePosition: index,
                })),
              }),
            });
            // If a different item was dragged to top, switch to it (preserve play state)
            const newTop = reordered[0];
            if (newTop && newTop.id !== nowPlayingId) {
              play(newTop, false, isPlaying);
            }
          }}
        />
      </div>
    </div>
  );
};

export default Queue;
